// extracted by mini-css-extract-plugin
export var description = "Inputs-module--description--Qp0DZ";
export var inline = "Inputs-module--inline--9iVWB";
export var root = "Inputs-module--root--jbbLX";
export var tooltip = "Inputs-module--tooltip--61I0U";